import { ShipAndProcessLineDto } from "./ship-and-process-line-dto.model";

export class ShipAndProcessDto {
    orderId = 0;
    userId = '';
    trackingNumber = '';
    shipAndProcessLineDtos: ShipAndProcessLineDto[] = [];
}
    
 